(() => {
  const config = document.getElementById('gg-cart-gift-config');
  if (!config) return;
  const {variantId, threshold, enabled} = JSON.parse(config.textContent);
  if (!enabled || !variantId) return;
  const root = window.Shopify?.routes?.root || '/';
  const originalFetch = window.fetch.bind(window);
  const marker = 'stg-over-200';
  let queue = Promise.resolve();
  const request = async (path, body) => {
    const response = await originalFetch(root + path, body ? {
      method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify(body)
    } : {headers: {Accept: 'application/json'}, cache: 'no-store'});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Gift unavailable');
    return result;
  };
  const isGift = item => item.variant_id === variantId && item.properties?._gg_free_gift === marker;
  async function reconcile(existing) {
    let cart = existing || await request('cart.js');
    const before = JSON.stringify(cart.items.map(item => [item.key, item.quantity, item.final_line_price]));
    const gifts = cart.items.filter(isGift);
    const rate = cart.currency === 'USD' ? 1 : Number(window.Shopify?.currency?.rate);
    const minimum = Number.isFinite(rate) && rate > 0 ? Math.round(threshold * rate) : Infinity;
    const spend = cart.items.reduce((sum, item) => sum + (isGift(item) || item.gift_card ? 0 : item.original_line_price), 0);
    const qualifies = spend >= minimum;
    if (!qualifies && gifts.length) {
      cart = await request('cart/update.js', {updates: Object.fromEntries(gifts.map(item => [item.key, 0]))});
    } else if (qualifies) {
      if (gifts.length && (gifts.length > 1 || gifts[0].quantity !== 1)) {
        cart = await request('cart/update.js', {updates: Object.fromEntries(gifts.map((item, index) => [item.key, index ? 0 : 1]))});
      } else if (!gifts.length) {
        try {
          await request('cart/add.js', {items: [{id: variantId, quantity: 1, properties: {_gg_free_gift: marker}}]});
          cart = await request('cart.js');
        } catch (_) {
          return {cart, changed: false};
        }
      }
      const hasFreeGift = cart.items.some(item => item.variant_id === variantId && item.final_price === 0);
      if (!hasFreeGift) {
        const chargedGifts = cart.items.filter(isGift);
        if (chargedGifts.length) cart = await request('cart/update.js', {updates: Object.fromEntries(chargedGifts.map(item => [item.key, 0]))});
      }
    }
    return {cart, changed: before !== JSON.stringify(cart.items.map(item => [item.key, item.quantity, item.final_line_price]))};
  }
  async function sectionsFor(ids) {
    if (!ids.length) return {};
    return Object.fromEntries(await Promise.all(ids.map(async id => {
      const url = new URL(window.location.pathname, window.location.origin);
      url.searchParams.set('section_id', id);
      const response = await originalFetch(url, {headers: {Accept: 'text/html'}, cache: 'no-store'});
      if (!response.ok) throw new Error('Cart section unavailable');
      return [id, await response.text()];
    })));
  }
  window.fetch = function(input, init) {
    const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.origin);
    const method = (init?.method || (input instanceof Request ? input.method : 'GET')).toUpperCase();
    if (url.origin !== window.location.origin || method !== 'POST' || !/\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname)) {
      return originalFetch(input, init);
    }
    const operation = queue.then(async () => {
      const response = await originalFetch(input, init);
      if (!response.ok) return response;
      try {
        const original = await response.clone().json();
        const {cart, changed} = await reconcile(typeof original.total_price === 'number' && Array.isArray(original.items) ? original : null);
        if (!changed) return response;
        const ids = Object.keys(original.sections || {});
        const sections = await sectionsFor(ids);
        const result = /\/add(\.js)?$/.test(url.pathname) ? {...original, sections} : {...original, ...cart, sections};
        return new Response(JSON.stringify(result), {status: response.status, headers: {'Content-Type': 'application/json'}});
      } catch (_) {
        return response;
      }
    });
    queue = operation.catch(() => {});
    return operation;
  };
  const initial = queue.then(async () => {
    const {cart, changed} = await reconcile();
    const drawer = document.querySelector('cart-modal');
    if (changed && drawer?.reloadContent) await drawer.reloadContent();
    const bubble = document.getElementById('CartBubble');
    if (bubble) {
      bubble.textContent = cart.item_count;
      bubble.classList.toggle('hidden', !cart.item_count);
    }
  });
  queue = initial.catch(() => {});
})();
